// new component based on the modal
import React from 'react';
import { useSelector } from 'react-redux';
import { hideStoreSelectorSheet, isStoreSelectorSheetOpen } from 'ducks/sheets';
import { KompisSheetHeader, KompisStoreSelectorCard } from '@inter-ikea-kompis/react-components';
import SheetBox from 'ui/Sheet/SheetBox';
import { useIntl } from 'react-intl';
import Sheet from 'ui/Sheet/Sheet';
import { reportSetStoreLocation } from 'analytics/reporters';
import { ReportCurrentPageEnum } from 'components/ProductSidebar/HomeDelivery/HomeDelivery';
import { useAvailability } from 'contexts/availability';
import { useAppDispatch } from 'ducks/hooks';
import { StoreIdCookieInformationService } from '@inter-ikea-kompis/services';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useServiceSettings } from 'contexts/serviceSettings';

export type SelectStoreEvent = {
  detail: {
    storeId: string;
    showSheet: boolean;
  };
};

function StoreSelectorSheet() {
  const dispatch = useAppDispatch();
  const visible = useSelector(isStoreSelectorSheetOpen);
  const { translations, dexfSettings } = useServiceSettings();
  const { storeId, stores } = useAvailability();
  const { formatMessage } = useIntl();
  const storeService = new StoreIdCookieInformationService({ settings: dexfSettings });

  const onClose = () => {
    dispatch(hideStoreSelectorSheet());
  };

  const onSelectStore = (event: SelectStoreEvent) => {
    reportSetStoreLocation({
      page: ReportCurrentPageEnum.productInfo,
      storeId: event.detail.storeId
    });

    storeService.setStoreId(event.detail.storeId);
    dispatch(hideStoreSelectorSheet());
  };
  if (!translations || !stores) {
    return null;
  }

  return (
    <Sheet
      onOverlayClick={() => dispatch(hideStoreSelectorSheet())}
      visible={visible}
      data-testid="storeselector-sheet"
    >
      <KompisSheetHeader
        theme={SkapaTheme}
        backIcon={false}
        onCloseButtonClick={onClose}
        onBackButtonClick={onClose}
        heading={formatMessage({ id: 'kompis.storeSelectorTitle' })}
      />
      <SheetBox>
        {translations && stores && (
          <KompisStoreSelectorCard
            storeId={storeId as any}
            onChange={onSelectStore}
            stores={stores}
            translations={translations.kompis}
            theme={SkapaTheme}
          />
        )}
      </SheetBox>
    </Sheet>
  );
}

export default StoreSelectorSheet;
